import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalGeneric } from '../models/modal-generic';

@Component({
  selector: 'app-dialogo-generico',
  templateUrl: './dialogo-generico.component.html',
  styleUrls: ['./dialogo-generico.component.css']
})
export class DialogoGenericoComponent {

  constructor(
    public dialogRefModal: MatDialogRef<DialogoGenericoComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: ModalGeneric
  ) { }

  cancelAllModals() {
    this.dialog.closeAll();
  }

  cancelModal() {
    this.dialogRefModal.close();
  }

  cancelWithAction() {
    this.dialogRefModal.close('action')
  }

}
